import { flatMap, _flatMap } from "./flatMap";

/**
 * {@inheritDoc flatMap}
 */
export const selectMany = flatMap;
/**
 * {@inheritDoc _flatMap}
 */
export const _selectMany = _flatMap;
